import React, { CSSProperties } from "react";

import DLSDropdown from "../../../dls/dls-dropdown";
import { IDSSDropdownProps } from "../../DSSFramework";
import "./index.scss"
import { ErrorView } from "../../molecule/error-view";
import DSSSpinner from "../dss-loader/dss-spinner";

export const DSSDropdown = (props: IDSSDropdownProps) =>
{
    return (
        <div className="dropdown-container">
            <DLSDropdown
                { ...{ ...props, required: props.required ?? true } }
            />
            { props.loading && <DSSSpinner id="spinner" style={ spinerStyle } /> }
            { props.fieldTouched && props.fieldErrors && (
                <ErrorView errors={ props.fieldErrors } />
            ) }
        </div>
    );
};

const spinerStyle = {
    position: 'absolute',
    width: "1rem",
    height: "1rem",
    borderWidth: "thick",
    top: '60%',
    bottom: 0,
    right: '2%'
} as CSSProperties;